import { render } from "./Gist.vue?vue&type=template&id=736d2724&scoped=true"
import script from "./Gist.vue?vue&type=script&lang=js"
export * from "./Gist.vue?vue&type=script&lang=js"

import "./Gist.vue?vue&type=style&index=0&id=736d2724&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736d2724"]])

export default __exports__